import { render, staticRenderFns } from "./PromoCardEditPage.vue?vue&type=template&id=13a8925a&scoped=true&"
import script from "./PromoCardEditPage.vue?vue&type=script&lang=ts&"
export * from "./PromoCardEditPage.vue?vue&type=script&lang=ts&"
import style0 from "./PromoCardEditPage.vue?vue&type=style&index=0&id=13a8925a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a8925a",
  null
  
)

export default component.exports